module.exports = __webpack_public_path__ + "static/media/Vamp1.6fd81ba8.png";